var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"#/yjTravel/home"}},[_c('img',{staticClass:"ctriplogo",attrs:{"src":_vm.logoImg,"alt":_vm.logoTitle}})])])}
var staticRenderFns = []

export { render, staticRenderFns }